import { render, staticRenderFns } from "./ClientsReportComponent.vue?vue&type=template&id=1d376360&scoped=true"
import script from "./ClientsReportComponent.vue?vue&type=script&lang=js"
export * from "./ClientsReportComponent.vue?vue&type=script&lang=js"
import style0 from "./ClientsReportComponent.vue?vue&type=style&index=0&id=1d376360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d376360",
  null
  
)

export default component.exports